import React from 'react';
import { FileText, Video } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import ActaFilesButtons, { companyActaFileUrl } from '@/components/debtor-portal/ActaFilesButtons';

const ActasCellPopover = ({ debtor }) => {
  const domains = debtor.domains || [];
  const actas = domains.flatMap(d => (d.actas || []).filter(a => a.number).map(a => ({ ...a, plate: d.plate })));
  if (actas.length === 0) return <span className="text-slate-400">-</span>;
  const pdfCount = actas.filter(a => a.pdf_file_id).length;
  const videoCount = actas.filter(a => a.video_file_id).length;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center gap-1.5 group" data-testid={`actas-cell-${debtor.id}`}>
          <Badge className="bg-amber-100 text-amber-800 group-hover:bg-amber-200 cursor-pointer">{actas.length} acta{actas.length > 1 ? 's' : ''}</Badge>
          {pdfCount > 0 && <span className="inline-flex items-center gap-0.5 text-[11px] text-rose-600" title={`${pdfCount} PDF`} data-testid={`actas-pdf-count-${debtor.id}`}><FileText className="w-3.5 h-3.5" />{pdfCount}</span>}
          {videoCount > 0 && <span className="inline-flex items-center gap-0.5 text-[11px] text-indigo-600" title={`${videoCount} video`} data-testid={`actas-video-count-${debtor.id}`}><Video className="w-3.5 h-3.5" />{videoCount}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-2 max-h-80 overflow-y-auto" data-testid={`actas-popover-${debtor.id}`}>
        <div className="space-y-1.5">
          {actas.map((a) => (
            <div key={`${a.plate}-${a.number}`} className={`rounded-md px-2 py-1.5 text-xs ${a.status === 'paid' ? 'bg-emerald-50' : 'bg-slate-50'}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="font-medium text-slate-800">Acta {a.number} <span className="font-mono text-slate-500">· {a.plate}</span></span>
                {a.status === 'paid' ? <span className="text-emerald-700 font-semibold">PAGADA</span> : (a.monto || a.monto_quita) ? <span className="text-slate-700">${(a.monto || a.monto_quita).toLocaleString('es-AR')}</span> : null}
              </div>
              {a.infraccion && <p className="text-slate-500 truncate">{a.infraccion}</p>}
              {(a.pdf_file_id || a.video_file_id)
                ? <div className="mt-1"><ActaFilesButtons acta={a} fileUrl={companyActaFileUrl} compact /></div>
                : <p className="text-[11px] text-slate-400 mt-0.5">Sin archivos adjuntos</p>}
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ActasCellPopover;
